import type { AsyncDataOptions } from '#app'

export default async function useLazyCachedAsyncData<
  ResT,
  NuxtErrorDataT = unknown,
  DataT = ResT,
  PickKeys extends KeysOf<DataT> = KeysOf<DataT>,
  DefaultT = undefined,
>(
  key: string,
  handler: () => Promise<ResT>,
  options?: Omit<
    AsyncDataOptions<ResT, DataT, PickKeys, DefaultT>,
    'getCachedData'
  >,
  expirationTime: number = 10 * 60 * 1000
) {
  return useCachedAsyncData<ResT, NuxtErrorDataT, DataT, PickKeys, DefaultT>(
    key,
    handler,
    { ...options, lazy: true },
    expirationTime
  )
}
